import React from 'react';
import {RoleAssignmentNoScopes} from '@touchnet/user-management';

import type {FC} from 'react';

import RoleDetailsProvider from '~/components/pages/user-mgmt/providers/role-details-provider'

export const ErpAdminRoleAssignment: FC = () => (<RoleAssignmentNoScopes DetailsProvider={RoleDetailsProvider} />);

export default ErpAdminRoleAssignment;
